import { Component, AfterViewInit, OnInit, OnDestroy, HostListener, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { Router, RouterEvent, NavigationEnd, NavigationExtras } from '@angular/router';
import { Subject, Observable, pipe } from 'rxjs';
import { takeUntil, map, filter } from 'rxjs/operators';
import { CommonService } from '@shared/service/common.service';
import { ItemService } from '@shared/service/items.service';
import { ModalSuccessComponent } from '@shared/modal/modal-success/modal-success.component';
import { GenericSliderService } from '@shared/service/genericSlider.service';
import { SiteService } from '@shared/service/site.service';
import { SiteModel } from '@core/model/site.model';
import { UserService } from '@shared/service/user.service';
import { UserModel } from '@core/model/user.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { utiles } from '@utl/environment';
import { ProductFamilyModel } from '@core/model/productFamily.model';
import { NavService } from '../../service/nav.service';
import { CutsProjectModel } from '@core/model/custProject.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalBranchOfficeComponent } from '@shared/modal/modal-branch-office/modal-branch-office.component';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(map((result) => result.matches));
  private unsubscribe$ = new Subject<void>();
  siteModel: SiteModel = new SiteModel();
  listAddress: any[] = [];
  listCustAddress: any[] = [];
  listSiteAddress: any[] = [];
  listCurrency: any[] = [];
  listClients: MasterClientModel[] = [];
  listProjects: CutsProjectModel[] = [];
  modelProjects: CutsProjectModel;
  logoUrl = '';
  itemsQtyInCart = 0;
  savedCartsQty = 0;
  colorExpiration = '';
  userModel: UserModel;
  public selectedSite = '';
  public selectedClient = '';
  public selectedCurrency = '';
  public selectedProject = '';
  public productSearch = '';
  public selectedFamily: ProductFamilyModel = new ProductFamilyModel();
  public listFamily: ProductFamilyModel[] = [];
  optionDisabled: ProductFamilyModel = new ProductFamilyModel();
  labelProject = false;
  selectedAddress = '';
  selectedSpecAddress = ''
  ShoppingCartId = 0;
  private masterClientModel: MasterClientModel = new MasterClientModel();
  showHeaderFilter = true;
  showSearchBar = true;
  familyUrl = '';
  @ViewChild("myNameElem") myNameElem: ElementRef;

  buttonFloat: any;

  // HostListener is used to display the scroll button depending on the required pixels
  @HostListener('window:scroll', [''])
  doSomethingOnInternalScroll() {
    this.buttonFloat = document.getElementById('float') as HTMLFormElement;
    // When the user scrolls down 145px from the top of the document, show the button
    if (document.body.scrollTop > 145 || document.documentElement.scrollTop > 145) {
      this.buttonFloat.style.display = 'block';
    } else {
      this.buttonFloat.style.display = 'none';
    }
  }

  name = 'Angular';
  left = 0;
  @ViewChild('parentTag', {static: false})
  parentTag: ElementRef; 

  @ViewChild('target', {static: false})
  target: ElementRef;

  constructor(
    private el:ElementRef, 
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
    private common: CommonService,
    private genericSliderService: GenericSliderService,
    private siteService: SiteService,
    private itemService: ItemService,
    private userService: UserService,
    public navService: NavService,
    public dialog: MatDialog,
    private productFamilyService: ProductFamilyService) {
    router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: RouterEvent) => {
        if (e.url === '/dashboard') {
          this.showHeaderFilter = true;
          this.showSearchBar = true;
          this.common.setFamilyQuery(null);
        } else {
          this.showHeaderFilter = false;
          this.showSearchBar = e.url.includes('/searchproduct') ? true : false;
          if (e.url.includes('/searchproduct')) {
            let value = e.url.split('?')[1];
            value = decodeURI(value);
            let array = value.split(',');

            array.forEach(element => {
              if (element.includes('keyWord')) {
                this.productSearch = element.split(':')[1].replace('"', '').replace('"', '').replace('%2F', '/');
              }
            });
            this.familyUrl = array[0].split(':')[1];
            this.listFamily.forEach(element => {
              if (this.familyUrl.includes(element.FamilyId)) {
                this.selectedFamily = element;
                utiles.clearCacheSelectedFamily();
                utiles.createCacheSelectedFamily(element);
              }
            });
          }
        }
      });
  }

  showUpButton() {
    let showBtt = true;
    if (window.location.hash === '#/shoppingcart') {
      showBtt = false;
    }
    return showBtt;
  }

  ngOnInit() {
    let data = utiles.getCacheUser();
    if (data !== null && data !== undefined) {
      this.setUserData();
      this.onGetLogo();
      this.onGetCurrencyList();
      this.onGetActiveProductFamilies();

      // Observable to update the shopping cart counter
      this.common.UpdateShoppingCart.pipe(takeUntil(this.unsubscribe$)).subscribe(update => {
        if (update) {
          this.onGetItemsQtyInCart();
          this.onGetSavedCartsQty();
          this.onGetActiveAddress();
          this.common.setUpdateShoppingCart(false);
        }
      });

      // Observable to update CustAddress
      this.common.UpdateCurrentAddress.pipe(takeUntil(this.unsubscribe$)).subscribe(update => {
        if (update) {
          this.onGetActiveAddress();
          this.common.setUpdateCurrentAddress(false);
        }
      });
    } else {
      this.router.navigate(['login']);
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onGetCurrencyList() {
    this.userService
    .getCurrencyList('ext')
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((response) => {
      this.listCurrency = response;
      this.onGetCutsUsers();
    });
  }

  scrolltop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 35);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  setUserData() {
    this.userModel = utiles.getCacheUser();
  }

  onGetLogo() {
    this.genericSliderService
      .getLogo()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.logoUrl = response.UrlImage;
      });
  }
  
  async onGetItemsQtyInCart() {
    let address = utiles.getCacheSelectedAddress();
    let dataModel = {
      UserId: this.userModel.UserId,
      CustAccount: this.selectedClient,
      ProjectId: this.selectedProject,
      SiteId: address !== null && address !== undefined ? address.SiteIdDelivery : '',
      Currency: this.selectedCurrency
    };
    let response = await this.userService.getItemsQtyInCart(dataModel).then()
        this.itemsQtyInCart = response;
        await this.onGetColorCartByExpiration();
  }
  
  onGetCutsUsers() {
    this.userService
      .getCustUsers(this.userModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.listClients = [];
        this.listProjects = [];
        if (response !== null) {
          if (response.length > 0) {
            response.forEach((entry) => {
              if (
                entry.ProjectList === undefined ||
                entry.ProjectList === null
              ) {
                entry.ProjectList = [];
                let project = new CutsProjectModel();
                project.ProjectName = 'Sin seleccionar proyecto';
                entry.ProjectList.push(project);
              } else {
                let project = new CutsProjectModel();
                project.ProjectName = 'Sin seleccionar proyecto';
                entry.ProjectList.push(project);
              }
            });
            this.listClients = response;
            const cust = utiles.getCacheSelectedClient();
            if (cust === null || !cust.CustAccount || cust.CustAccount === undefined) {
              this.selectedClient = response[0].CustAccount;
              let model = {};
              this.listClients.forEach((entry) => {
                if (entry.CustAccount === this.selectedClient) {
                  model = entry;
                  utiles.clearCacheSelectedClient();
                  utiles.createCacheSelectedClient(model);
                  this.common._setSelectedClient(model);
                }
              });
            } else {
              this.selectedClient = cust.CustAccount;
              this.common._setSelectedClient(cust);
            }

            response.forEach((entry) => {
              if(entry.CustAccount === this.selectedClient) {
                entry.ProjectList.forEach((proyecto) => {
                  this.listProjects.push(proyecto);
                });
              }
            });
            
            const currency = utiles.getCacheSelectedCurrency();
            if (currency === null || !currency.CurrencyId || currency.CurrencyId === undefined) {
              this.selectedCurrency = response[0].Currency;
              let model = {};
              this.listCurrency.forEach((entry) => {
                if (entry.CurrencyId === this.selectedCurrency) {
                  model = entry;
                  utiles.clearCacheSelectedCurrency();
                  utiles.createCacheSelectedCurrency(model);
                  this.common._setSelectedCurrency(model);
                }
              });
            } else {
              this.selectedCurrency = currency.CurrencyId;
              utiles.clearCacheSelectedCurrency();
              utiles.createCacheSelectedCurrency(currency);
            }

            if (this.listProjects.length > 0) {
              const proyecto = utiles.getCacheSelectedProject();
              if (proyecto === null || !proyecto.ProjectId || proyecto.ProjectId === undefined) {
                this.listProjects.forEach((entry) => {
                  if (entry.ProjectId === '') {
                    this.selectedProject = entry.ProjectId;
                    this.common._setSelectedProject(entry);
                    utiles.clearCacheSelectedProject();
                    utiles.createCacheSelectedProject(entry);
                  }
                });
                this.labelProject = true;
              }
              else {
                this.selectedProject = proyecto.ProjectId;
                this.common._setSelectedProject(proyecto);
                this.labelProject = true;
                utiles.clearCacheSelectedProject();
                utiles.createCacheSelectedProject(proyecto);
              }
            } else {
              this.labelProject = false;
              this.common._setSelectedProject(null);
              utiles.clearCacheSelectedProject();
            }

            this.onGetActiveAddress();
            this.onGetSavedCartsQty();
            this.onGetItemsQtyInCart();
          }
        } else {
          const data = new DataMessageModel();
          data.labelTitile = 'Lo sentimos, no hay clientes activos para este usuario. Contacte a Extralum para solucionar el problema.';
          const dialogRef = this.dialog.open(ModalSuccessComponent, {
            data,
            minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
          });
          this.router.navigate(['login']);
        }
        this.common._setMasterClientAvailable(response);
      });
  }

  changeCustAccount(data) {
    this.listClients.forEach((cust) => {
      if (cust.CustAccount === data.value) {
        this.getCustProjects(cust);
        this.common._setSelectedClient(cust);
        this.loadSitebyClient();
        utiles.clearCacheSelectedAddress();
        this.onGetActiveAddress();
        this.onGetItemsQtyInCart();
        this.onGetSavedCartsQty();
      }
    });
  }

  getCustProjects(cust) {
    this.listProjects = [];
    utiles.clearCacheSelectedClient();
    utiles.createCacheSelectedClient(cust);
    this.selectedCurrency = cust.Currency;
    utiles.clearCacheSelectedCurrency();
    let model = {};
    this.listCurrency.forEach((moneda) => {
      if (moneda.CurrencyId === this.selectedCurrency) {
        model = moneda;
        utiles.createCacheSelectedCurrency(model);
        this.common._setSelectedCurrency(model);
      }
    });
    cust.ProjectList.forEach((project) => {
      this.listProjects.push(project);
    });
    
    utiles.clearCacheSelectedProject();
    if (this.listProjects.length > 0) {
      this.listProjects.forEach((project) => {
        if (project.ProjectId === '') {
          this.common._setSelectedProject(project);
          this.selectedProject = '';
          utiles.createCacheSelectedProject(project);
        }
      });
    } else {
      let project = new CutsProjectModel();
      project.ProjectName = 'Sin seleccionar proyecto';
      this.common._setSelectedProject(project);
      this.selectedProject = '';
      utiles.createCacheSelectedProject(project);
    }
  }

  loadSitebyClient() {
    let findSite = false;
    this.listClients.forEach((entry) => {
      if (entry.CustAccount === this.selectedClient) {
        this.listAddress.forEach((site) => {
          if (site.SiteId === entry.SiteId) {
            this.common._setSelectedSite(site);
            findSite = true;
          }
        });
      }
    });
    if (!findSite) {
      this.common._setSelectedSite(this.listAddress[0]);
    }
  }

  onGetActiveAddress() {
    let vTieneDireccion;

    if (this.selectedClient !== '') {
      this.siteService.getActiveAddressList(this.selectedClient, this.selectedProject, this.userModel.UserId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.listAddress = response;
        this.listCustAddress = [];
        this.listSiteAddress = [];
        response.forEach(element => {
          if (element.AddressType === 2) {
            this.listSiteAddress.push(element);
          } else {
            this.listCustAddress.push(element);
          }
        });
        let addressCache = utiles.getCacheSelectedAddress();
        addressCache = addressCache !== null && addressCache !== undefined ? addressCache.DeliveryPostalAddressId : '';
        if (addressCache !== '') {
          response.forEach(element => {
            if (element.AddressId === addressCache) {
              this.changeAddress(element.AddressId);
            }
          });
        } else {
          const vCacheUser = utiles.getCacheUser();
          const dataModel = {
            UserId: vCacheUser.UserId,
            CustAccount: this.selectedClient,
            ProjectId: this.selectedProject,
            SiteId: this.selectedSite,
            Currency: this.selectedCurrency
          };
          this.userService.getCurrentshoppingCartAddress(dataModel)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((responseAddress) => {
            if (responseAddress !== null && responseAddress[0].AddressListId !== '') {
              const selectedAddress = responseAddress[0].AddressListId;
              this.changeAddress(selectedAddress);
            } else {
              response.forEach(element => {
                if (element.IsPrimary === 1) {
                  this.changeAddress(element.AddressId);
                  vTieneDireccion = true;
                } 
              });
              if (!vTieneDireccion) {
                this.openModalChangeAddress(true);
              }
            }
          });
        }
      });
    }
  }
  
  onGetActiveProductFamilies() {
    let model = new ProductFamilyModel();

    this.productFamilyService
      .getActiveProductFamiliesList(model)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.listFamily = response;
        localStorage.setItem('listFamily', JSON.stringify(response));
        let family = utiles.getCacheSelectedFamily();
        if (family !== null && family !== undefined) {
          response.forEach(element => {
            if (element.FamilyId === (this.selectedFamily.FamilyId !== '' ?
              this.familyUrl.includes(element.FamilyId) ? element.FamilyId : this.selectedFamily.FamilyId : family.FamilyId)) {
              this.selectedFamily = element;
              this.setSelectedFamily(element);
            }
          });
        }
      });
  }
  
  goToShoppingCart() {
    this.router.navigate(['shoppingcart']);
  }
  
  goToDashboard() {
    this.router.navigate(['dashboard']);
  }
  
  goToWhishList() {
    this.router.navigate(['whishlist']);
  }
  
  LogOut() {
    utiles.clearAllCache();
    this.router.navigate(['login']);
  }
  
  goToSettings() {
    this.router.navigate(['setting']);
  }
  
  goToAccount() {
    this.router.navigate(['account']);
  }
  
  goToOrderList() {
    this.router.navigate(['orderlist']);
  }

  goToShoppingList() {
    this.router.navigate(['shoppingcartdetail']);
  }

  openModalChangeAddress(disableClose: boolean = false) {
    const dialogRef = this.dialog.open(ModalBranchOfficeComponent, {
      data: {
        labelTitile: 'Seleccione el destino de la compra',
        listAddress: this.listAddress,
        listCustAddress: this.listCustAddress,
        listSiteAddress: this.listSiteAddress,
      },
      panelClass: ['without-padding'],
      maxHeight: '74vh',
      minHeight: '74vh',
      maxWidth: '100%',
      disableClose: disableClose
    });
    dialogRef.componentInstance.selectAddress
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((result) => {
      this.changeAddress(result, true);
    });

    if(!disableClose)
      setTimeout(() => dialogRef.close(), 100000);
  }
  
  changeProject() {
    this.labelProject = true;

    let model = {};
    this.listProjects.forEach((entry) => {
      if (entry.ProjectId === this.selectedProject) {
        model = entry;
      }
    });
    this.common._setSelectedProject(model);
    utiles.clearCacheSelectedProject();
    utiles.createCacheSelectedProject(model);
    utiles.clearCacheSelectedAddress();
    this.onGetActiveAddress();
    this.onGetItemsQtyInCart();
    this.onGetSavedCartsQty();
  }

  changeCurrency() {
    let model = {};
    this.listCurrency.forEach((entry) => {
      if (entry.CurrencyId === this.selectedCurrency) {
        model = entry;
        this.common._setSelectedCurrency(model);
        utiles.clearCacheSelectedCurrency();
        utiles.createCacheSelectedCurrency(model);
        utiles.clearCacheSelectedAddress();
        const vCacheUser = utiles.getCacheUser();
        const dataModel = {
          UserId: vCacheUser.UserId,
          CustAccount: this.selectedClient,
          ProjectId: this.selectedProject,
          SiteId: this.selectedSite,
          Currency: this.selectedCurrency
        };
        this.userService
          .getCurrentCartId(dataModel)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.ShoppingCartId = response;
            this.onGetItemsQtyInCart();
            this.onGetSavedCartsQty();
          });
      }
    });
    this.onGetActiveAddress();
  }
  
  setSelectedFamily(family, changePage?) {
    utiles.clearCacheSelectedFamily();
    this.selectedFamily = family;
    this.common._setSelectedFamily(family);
    utiles.createCacheSelectedFamily(family);
    if (changePage !== undefined) {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          query: JSON.stringify({
            family: this.selectedFamily.FamilyId,
            pager: 1,
            keyWord: '',
            filter: []
          })
        },
        skipLocationChange: false
      };
      this.router.navigate(['searchproduct'], navigationExtras);
    }
  }

  handleKeyDown(event) {
    if (this.selectedFamily.FamilyId !== '') {
      if (event.keyCode === 13 || event.type === 'click') {
        this.productSearch = this.productSearch.replace(/[^a-zA-Z0-9/ ]/g, '');
        this.setProductSearch();

        let url = window.location.href;
        let value = url.substring(url.lastIndexOf('/') + 1);
        value = decodeURIComponent(value);
        let arrayFilters = [];
        arrayFilters = value.split('filter=');

        let exist = arrayFilters.some((item) => {
          return item.includes('searchproduct');
        });

        if (exist) {
          this.setProductSearch();
        } else {
          utiles.createCacheSelectedCustomer(this.modelProjects);
          this.setProductSearch();
          this.setSelectedFamily(this.selectedFamily);
          let navigationExtras: NavigationExtras = {
            queryParams: {
              query: JSON.stringify({
                family: this.selectedFamily.FamilyId,
                pager: 1,
                keyWord: this.productSearch,
                filter: []
              })
            },
            skipLocationChange: false
          };
          this.router.navigate(['searchproduct'], navigationExtras);
        }
      }
    } else {
      let data = new DataMessageModel();
      data.labelTitile =
        'Debe seleccionar una familia para realizar la busqueda.';
      this.common.onSuccessModal(data);
    }
  }
  
  setProductSearch() {
    this.common._setProductSearch(this.productSearch);
  }

  changeAddress(AddressId, _updateBD: boolean = false) {
    let vTieneDir = false;
    let i = 0;
    if (AddressId !== '') {
      this.listAddress.forEach((entry) => {
        i++;
        if (entry.AddressId === AddressId) {
          let vTempSite = new SiteModel();
          vTempSite.SiteId = entry.LinkSite;

          const vCacheUser = utiles.getCacheUser();
          const dataModel = {
            UserId: vCacheUser.UserId,
            CustAccount: this.selectedClient,
            ProjectId: this.selectedProject,
            SiteId: this.selectedSite,
            Currency: this.selectedCurrency
          };

          this.userService
          .getCurrentCartId(dataModel)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((response) => {
            this.ShoppingCartId = response;
            const model = {
              ShoppingCartId: this.ShoppingCartId,
              SiteId: vTempSite.SiteId
            };
            this.itemService.ValidateInventAvailableByCart(model)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
            Validacion => {
              this.assignAddress(
                entry.AddressId,
                entry.LinkSite,
                entry.AddressType,
                this.ShoppingCartId,
                _updateBD
              );
              if (Validacion !== true) {
                const data = new DataMessageModel();
                data.labelTitile = 'Lo sentimos, hay artículos agregados que no cuenta con la cantidad suficiente para esta dirección!.';
                const dialogRef = this.dialog.open(ModalSuccessComponent, {
                  data,
                  minWidth: '42vw', maxWidth: '90vw', maxHeight: '90vh', minHeight: '23vh'
                });
              }
            });
          });
          vTieneDir = true;
        } else if(i == this.listAddress.length && vTieneDir == false) {
          this.router.navigate(['dashboard']);
          this.openModalChangeAddress(true);
        }
      });
    }
  }

  assignAddress(addressId: string, siteId: string, Source: number, shoppingcartId: number, _updateBD: boolean) {
    const vCacheUser = utiles.getCacheUser();
    this.ShoppingCartId = shoppingcartId;
    this.listAddress.forEach(element => {
      if (element.AddressId === addressId) {
        const model = {
          ShoppingCartId: this.ShoppingCartId,
          DeliveryPostalAddressId: addressId,
          SiteIdDelivery: siteId,
          SiteAddress: element.SiteName
        };
        this.selectedAddress = addressId;
        this.selectedSpecAddress = element.SpecificAddress;
        this.selectedSite = siteId;
        this.siteService.getActiveSiteList()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((SiteList) => {
          SiteList.forEach(elementSite => {
            if (elementSite.SiteId === siteId) {
              this.common._setSelectedSite(elementSite);
            }
          });
        });
        if (this.ShoppingCartId !== 0 && _updateBD) {
          this.userService
          .updateShoppingCartInfo(model)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(response => {
            this.common._setSelectedAddress(model);
            utiles.clearCacheSelectedAddress();
            utiles.createCacheSelectedAddress(model);
          });
        }
        else {
          this.common._setSelectedAddress(model);
          utiles.clearCacheSelectedAddress();
          utiles.createCacheSelectedAddress(model);
        }
      }
    });
  }

  onGetSavedCartsQty() {
    let dataModel = {
      UserId: this.userModel.UserId,
      CustAccount: this.selectedClient,
      ProjectId: this.selectedProject,
      Currency: this.selectedCurrency
    };
    this.userService
    .getSavedCartsQty(dataModel)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((response) => {
      this.savedCartsQty = response;
      this.onGetColorCartByExpiration();
    });
  }

  onGetColorCartByExpiration() {
    let dataModel = {
      UserId: this.userModel.UserId,
      CustAccount: this.selectedClient,
      ProjectId: this.selectedProject,
      Currency: this.selectedCurrency
    };

    this.userService
    .getColorCartByExpiration(dataModel)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((response) => {
      if (response) {
        this.colorExpiration = response[0].colorId;
      }
    });
  }
}
